export class GcpRestoreAccountAttributes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "serviceAccount",
            "baseName": "serviceAccount",
            "type": "string",
            "format": ""
        },
        {
            "name": "hostProjectId",
            "baseName": "hostProjectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "restrictTargetRestoreGcsByTag",
            "baseName": "restrictTargetRestoreGcsByTag",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "organizationId",
            "baseName": "organizationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "folderId",
            "baseName": "folderId",
            "type": "string",
            "format": ""
        },
        {
            "name": "optionalCapabilities",
            "baseName": "optionalCapabilities",
            "type": "GcpOptionalCapabilities",
            "format": ""
        },
        {
            "name": "grantedServices",
            "baseName": "grantedServices",
            "type": "GcpRestoreGrantedServices",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpRestoreAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
